import { UtilitarioService } from '../../../../services/utilitario.service';
import { Component, OnInit, ViewChild, TemplateRef, Output, EventEmitter, Inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ReceberService } from '@app/services/receber.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Paginacao } from '@app/models/util/paginacao';
import { PagarService } from '@app/services/pagar.service';
import { Pagar } from '@app/models/pagar.model';
import { PagarPesquisa } from '@app/models/pagar-pesquisa';
import { ProcessoService } from '@app/services/processo.service';
import { ToastrService } from 'ngx-toastr';
import { PesquisaRelatorio } from '@app/models/pesquisa-relatorio';
import { ProcessoResumo } from '@app/models/processo.model';
import { ModalConfirmarComponent } from '@app/components/modal-confirmar/modal-confirmar.component';
import { UsuarioTipoService } from '@app/services/usuario-tipo.service';
import { IdDescricao } from '@app/models/util/id-descricao';
import { Baixa, BaixaFormaDePagamento, BaixaInformacoes } from '@app/models/baixa.model';
import { ConsultasService } from '@app/services/consultas.service';
import { MovimentacaoService } from '@app/services/movimentacao.service';
import { FinanceiroProcessoService } from '@app/services/financeiro-processo.service';
import { Permissoes } from '../permissoes-lista.model';

@Component({
  selector: 'app-financeiro-processo-titulos',
  templateUrl: './financeiro-processo-titulos.component.html',
  styleUrls: ['./financeiro-processo-titulos.component.scss']
})
export class FinanceiroProcessoTitulosComponent implements OnInit {
  @Output() preenchePermissao = new EventEmitter();
  @Output() preencheResumo = new EventEmitter();

  usuarioPermissoes: Permissoes = new Permissoes();
  processoResumo: ProcessoResumo = new ProcessoResumo();

  lstReceber: any[];
  pesquisaReceber = new PesquisaRelatorio(false);
  paginacaoReceber: Paginacao = new Paginacao();

  pesquisaPagar = new PesquisaRelatorio(false);
  lstPagar: PagarPesquisa[];
  pagamento: Pagar = new Pagar();
  paginacaoPagar: Paginacao = new Paginacao();
  lstParciais: PagarPesquisa[] = [];
  mapeamentoParciais: number;

  somenteNaoGerouAgrupamento = true;

  lstErros: string[];

  totalReceber = 0;
  totalPagar = 0;
  totalSaldo = 0;
  creditoDisponivelValor = 0;
  creditoIndisponivelValor = 0;

  parcialNovoNumero = '';

  tituloSaldo: string;
  tituloPagar: string;
  tituloReceber: string;

  agrupamentoReceberValor = 0;
  agrupamentoPagarValor = 0;

  ExisteParcial: boolean;

  decimoTerceiro: boolean = false;

  bsModalRef: BsModalRef;
  @ViewChild('modalAbaterCredito', {static: true}) modalAbaterCredito: TemplateRef<any>;
  @ViewChild('modalDevolucaoCredito', {static: true}) modalDevolucaoCredito: TemplateRef<any>;
  @ViewChild('modalEncerrarTutela', {static: true}) modalEncerrarTutela: TemplateRef<any>;
  @ViewChild('modalSaldoDevedor', {static: true}) modalSaldoDevedor: TemplateRef<any>;

  dataInicial13: string;
  decimoTerceiroIntegral: boolean = false;
  gerarDevolucaoCredito: boolean = false;
  dataEncerrarTutela: string;
  idEncerrarTutela: number = 0;


  lstContas: IdDescricao[];
  lstFormasDePagamento: IdDescricao[];
  lstBancos: IdDescricao[];
  formaDePagamento: BaixaFormaDePagamento;
  baixa = new Baixa();
  valorTotal = 0;
  valorTitulo = 0;
  baixaInformacoes = new BaixaInformacoes();

  aguardando: boolean = false;


  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private processoService: ProcessoService,
    private receberService: ReceberService,
    private pagarService: PagarService,
    @Inject(ToastrService) public toastr: ToastrService,
    private modalService: BsModalService,
    private consultasService: ConsultasService,
    private movimentacaoService: MovimentacaoService,
    private financeiroProcessoService: FinanceiroProcessoService,
    private usuarioTipoService: UsuarioTipoService
  ) {
    this.router.events.subscribe(() => window.scrollTo(0, 0));
    this.formaDePagamento = new BaixaFormaDePagamento();
  }

  ngOnInit() {
    this.route.parent.params.subscribe(
      (params: any) => {
        const id = params['id'];
        this.processoService.obterResumo(id).subscribe(data => {
          this.processoResumo = data;
          this.preencheResumo.emit(this.processoResumo);
          this.pesquisaPagar.ProcessoId = id;
          this.pesquisaReceber.ProcessoId = id;
          this.pesquisaPagar.SomenteLiberadas = false;
          this.obterResumo();
        });
      });

      this.usuarioTipoService.verificaPermissaoUsuario().subscribe(
        (permissoes: any) =>{
          this.usuarioPermissoes.Pagar = permissoes.find(x => x.Descricao == 'VisualizarPagar').Selecionado;
          this.usuarioPermissoes.Receber = permissoes.find(x => x.Descricao == 'VisualizarReceber').Selecionado;
          this.usuarioPermissoes.EditarExcluir = permissoes.find(x => x.Descricao == 'EditarExcluirTitulos').Selecionado;
          this.usuarioPermissoes.NovosLancamentos = permissoes.find(x => x.Descricao == 'FazerLancamentos').Selecionado;
          this.usuarioPermissoes.ReceberComCredito = permissoes.find(x => x.Descricao == 'ReceberComCreditoCliente').Selecionado;
          this.usuarioPermissoes.Estorno = permissoes.find(x => x.Descricao == 'RealizarEstorno').Selecionado;
          this.usuarioPermissoes.EmitirNota =  permissoes.find(x => x.Descricao == 'EmitirNotaFiscal').Selecionado;
          this.usuarioPermissoes.Cliente =  permissoes.find(x => x.Descricao == 'Ambiente_Cliente').Selecionado;
          this.preenchePermissao.emit(this.usuarioPermissoes.NovosLancamentos);
      });
  
      this.consultasService.consultar('CONTA').subscribe(data => this.lstContas = data);
  }

  obterResumo() {
    this.filtrar('naopagas');
    this.obterCredito(this.processoResumo.ClienteId);
    this.procurarSaldoDevedor(this.processoResumo.ClienteId, this.processoResumo.Id);
  }

  
  validaDevolucaoCredito(){
    this.aguardando = true;

    if(this.formaDePagamento.contaId === 0 || this.formaDePagamento.contaId === null || this.formaDePagamento.contaId === undefined) {
      this.toastr.error('O campo CONTA/BANCO é obrigatório');
      this.aguardando = false;
      return;
    }
    if(this.formaDePagamento.formaDePagamentoId === 0 || this.formaDePagamento.formaDePagamentoId === null || this.formaDePagamento.formaDePagamentoId === undefined) {
      this.toastr.error('O campo Forma de Pagamento é obrigatório');
      this.aguardando = false;
      return;
    }

    if(this.formaDePagamento.CadastrarCheque)
      this.validaCheque();

    this.baixa.formaDePagamento[0] = this.formaDePagamento;
    this.realizarBaixa(true);
  };

  ativaCheque() {
    const valorCampo = this.lstFormasDePagamento.find((item) => item.Id === this.formaDePagamento.formaDePagamentoId);
    this.formaDePagamento.CadastrarCheque = <boolean>valorCampo.Extra2;
  }

  validaCheque() {
    if(!this.formaDePagamento.CadastrarCheque)
      return true;

    if (!this.formaDePagamento.ChequeBancoId || this.formaDePagamento.ChequeBancoId < 1) {
      this.toastr.error('Banco  do cheque não informado');
      return false;
    }

    if (!this.formaDePagamento.ChequeAgencia) {
      this.toastr.error('Agência do cheque não informada.');
      return false;
    }

    if (!this.formaDePagamento.ChequeConta) {
      this.toastr.error('Conta  do cheque não informada.');
      return false;
    }

    if (!this.formaDePagamento.ChequeNumero) {
      this.toastr.error('Número do cheque não informado.');
      return false;
    }

    if (!this.formaDePagamento.ChequeTitular) {
      this.toastr.error('Titular do cheque não informado.');
      return false;
    }

    if (!this.formaDePagamento.ChequeDataEmissao) {
      this.toastr.error('Data de emissão do cheque não informada.');
      return false;
    }

    if (!this.formaDePagamento.ChequeDataVencimento) {
      this.toastr.error('Data de vencimento do cheque não informada.');
      return false;
    }

  }

  validaBaixaCredito(){ 
    this.aguardando = true;
    if(this.formaDePagamento.valor == 0){
      this.toastr.error('Valor do recebimento obrigatório!');
      this.aguardando = false;
      return;
    }

    if(this.formaDePagamento.valor > this.creditoDisponivelValor) {
      this.toastr.error('Valor não pode ser maior que o crédito disponível!');
      this.aguardando = false;
      return;
    }

    if(this.formaDePagamento.valor > this.valorTitulo) {
      this.toastr.error('Valor não pode ser maior que o valor do título!');
      this.aguardando = false;
      return;
    }
    
    this.baixa.formaDePagamento[0] = this.formaDePagamento;
    this.realizarBaixa();
  }

  
  realizarBaixa(devolucao:boolean = false){
    var abater = !devolucao;

    this.baixa.Tipo =  devolucao ? 'PAGAR' : 'RECEBER';
    this.baixa.valor = this.formaDePagamento.valor;
    this.baixa.valorRecebido = this.formaDePagamento.valor;
    this.baixa.valorRestante =  this.valorTitulo - this.baixa.valorRecebido;
    this.baixa.dataPagamento = UtilitarioService.retornaDataAtualMaisDias(0);
    this.baixaInformacoes.Troco = 0;
    this.baixaInformacoes.Desconto = 0;
    this.baixaInformacoes.Juros = 0;
    //this.baixaInformacoes.Numero = this.parcialNovoNumero;
    this.baixaInformacoes.Historico = '';
    this.baixaInformacoes.Credito = false;
    this.baixaInformacoes.DataBaixa = this.baixa.dataPagamento;
    this.baixaInformacoes.Numero = this.parcialNovoNumero;
    
    this.movimentacaoService.baixar(this.baixa, this.baixaInformacoes, abater, devolucao)
      .toPromise().then(
        (data: any) => {
          if (devolucao) {
            const newTab = window.open();
            newTab.location.href = window.location.href.split('#')[0] +
            '#/recibo/P/' + data._pagarId;
          }
          this.obterResumo();
          this.bsModalRef.hide();
          this.aguardando = false;
        },
        (data) => {
          this.toastr.error(data.error.errors[0]);
          this.aguardando = false;
        }
        
      );
      console.table(this.baixa);
  }
  // modal do Abater com Credito #modalAbaterCredito
  
  fecharModal(){
    this.bsModalRef.hide();
  }

  abrirModalAbaterComCredito(receberId: number) {

    this.receberService.obterPorId(receberId).subscribe((data: any) => {
      this.baixaInformacoes.NovoVencimento = data.Vencimento?.split('T')[0];
      this.baixa.documentoId = data.Id;
      this.baixa.processoId = data.ProcessoId;
      this.parcialNovoNumero = data.Numero;
      this.valorTitulo = this.formaDePagamento.valor = data.Valor;
      this.formaDePagamento.valor = this.valorTitulo > this.creditoDisponivelValor ? this.creditoDisponivelValor : this.valorTitulo;
    });

    this.bsModalRef = this.modalService.show(this.modalAbaterCredito, { class: 'modal-lg' });

  }

  // Abrir modal Devolucao Credito
  abrirModalDevolucaoCredito(pagarId: number){
    this.consultasService.consultar('FORMADEPAGAMENTO_D').subscribe(data => this.lstFormasDePagamento = data);
    this.consultasService.consultar('BANCO').subscribe(data => this.lstBancos = data);
    this.pagarService.obterPorId(pagarId).subscribe((data: any) => {
      this.baixaInformacoes.NovoVencimento = data.Vencimento?.split('T')[0];
      this.baixa.documentoId = data.Id;
      this.baixa.processoId = data.ProcessoId;
      this.parcialNovoNumero = data.Numero;
      this.valorTitulo = this.formaDePagamento.valor = data.Valor > this.creditoDisponivelValor ? this.creditoDisponivelValor : data.Valor; 
    });
    this.bsModalRef = this.modalService.show(this.modalDevolucaoCredito, { class: 'modal-lg' });
  }

  //modal encerrar tutela
  abrirModalEncerrarTutela(id: number) {
    this.bsModalRef = this.modalService.show(this.modalEncerrarTutela);
    this.idEncerrarTutela = id;
    this.dataEncerrarTutela = UtilitarioService.retornaDataAtualMaisDiasISO(0);
  }

  encerrarTutela(){
    this.aguardando = true;

    this.financeiroProcessoService.encerraTutela(this.idEncerrarTutela,
      this.dataEncerrarTutela, 
      this.decimoTerceiro,
      this.decimoTerceiroIntegral,
      this.gerarDevolucaoCredito,
      this.dataInicial13
      ).subscribe(() => {
          this.obterCredito(this.processoResumo.ClienteId);
          this.receberObterTodos(this.pesquisaReceber, 1);
          this.pagarObterTodos(this.pesquisaPagar,1);
          this.fecharModal();
          this.aguardando = false;
        },
        (data: any) => {
          if (data.error && data.error.errors) { 
            
            data.error.errors.forEach((mensagem: string) => {
              this.toastr.warning(mensagem);

            });
            
          this.obterCredito(this.processoResumo.ClienteId);
          this.receberObterTodos(this.pesquisaReceber, 1);
          this.pagarObterTodos(this.pesquisaPagar,1);
          this.fecharModal();
          
          this.aguardando = false;
        }
      });
  }
  
  //adicionar na prestação de contas
  adicionarPrestacaoDeContas(receberId: number){
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja adicionar divisão ao relatório de prestação de contas?';
    this.bsModalRef.content.confirmar = () => {
      //método para atualizar divisão de honorários
      this.financeiroProcessoService.adicionarPrestacaoDeContas(receberId).subscribe(() => {
        this.receberObterTodos(this.pesquisaReceber, 1);
        this.bsModalRef.hide();
      },
      () => {
        this.toastr.error("Algo deu errado, tente novamente");
      })
    };
  }

  procurarSaldoDevedor(participanteId: number, processoId: number){
    this.financeiroProcessoService.procurarSaldoDevedor(participanteId, processoId).subscribe(data => {
      if(data){
        this.bsModalRef = this.modalService.show(this.modalSaldoDevedor, { class: 'modal-sm' });
      }
    });
  }

  obterCredito(participanteId: number){
    this.financeiroProcessoService.obterCreditoParticipante(participanteId).subscribe((data: any) => {
      this.creditoDisponivelValor = data.CreditoDisponivel;
      this.creditoIndisponivelValor = data.CreditoIndisponivel;
      });
  }

  receberObterTodos(pesquisa: any, pagina: number) {
    pesquisa.Pagina = pagina;
    this.receberService.obterListaProcesso(pesquisa)
      .subscribe(data => {
        this.lstReceber = data.Dados;
        this.paginacaoReceber.totalDeItens = data.TotalDados;
        if(pesquisa.PagasRecebidas && pesquisa.NaoPagasRecebidas){
          this.totalReceber = data.TotalRecebidas + data.TotalReceber;
        }else if(pesquisa.PagasRecebidas){
          this.totalReceber = data.TotalRecebidas;
        }else{
          this.totalReceber = data.TotalReceber;
        }
        this.totalSaldo = this.totalReceber - this.totalPagar;
        this.totalSaldo = this.totalSaldo < 0 ? 0 : this.totalSaldo;
      },
      () => this.toastr.error('Recarregue a página para tentar novamente.', 'Problema ao pesquisar!')
      );
  }

  receberDeletar(id: number) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente deletar este contas a receber? (todas as contas a pagar vínculadas a este receber serão deletadas)';
    this.bsModalRef.content.confirmar = () => {
      this.lstErros = [];
      this.receberService.deletar(id).subscribe(
        () => {
          this.obterTodos();
          //this.obterTotais();
        },
        (data: any) => {
          if (data.error) {
            this.toastr.error(data.error.errors);
          }
        });
    };
  }

  receberEstorno(id: number) {
    this.lstErros = [];
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja realmente estornar este contas a receber? (todas as contas a pagar vínculadas a este receber serão estornadas)';
    this.bsModalRef.content.confirmar = () => {
      this.receberService.realizarEstorno(id)
        .subscribe(
          () => {
            this.obterTodos();
            this.obterCredito(this.processoResumo.ClienteId);
            //this.receberObterTodos(this.pesquisaReceber, 1);
            //this.obterTotais();
            //this.pagarObterTodos(this.pesquisaPagar, 1);
          },
          (data: any) => {
            if (data.error) {
              this.lstErros = data.error.errors;
              this.toastr.error(data.error.errors);
            }
          }
        );
    };
  }

  receberAgrupamento() {
    if (this.validaReceberPagar('RECEBER')) {
      this.receberService.realizarAgrupamento(this.pesquisaReceber.ProcessoId, this.agrupamentoReceberValor)
        .subscribe(
          (data: any) => {
            if (data.error) {
              this.lstErros = data.error.errors;
              this.toastr.error(data.error.errors);
            }
            this.router.navigate(
              ['./receber/realizarRecebimento/' + data.Id, 'processo',
              this.pesquisaReceber.ProcessoId,
              this.agrupamentoReceberValor
              ]
            );
          });
    }
  }

  public receberPageChanged(event: any): void {
    this.receberObterTodos(this.pesquisaReceber, event.page);
  }


  // pagar
  pagarObterTodos(pesquisa: any, pagina: number) {
    pesquisa.Pagina = pagina;
    this.pagarService.obterListaProcesso(pesquisa)
      .subscribe(data => {
        this.lstPagar = data.Dados,
          this.paginacaoPagar.totalDeItens = data.TotalDados;
          if(pesquisa.PagasRecebidas && pesquisa.NaoPagasRecebidas){
            this.totalPagar = data.TotalPagas + data.TotalPagar;
          }else if(pesquisa.PagasRecebidas){
            this.totalPagar = data.TotalPagas;
          }else{
            this.totalPagar = data.TotalPagar;
          }
          this.totalSaldo = this.totalReceber - this.totalPagar;
          this.totalSaldo = this.totalSaldo < 0 ? 0 : this.totalSaldo;
      },
      () => this.toastr.error('Recarregue a página para tentar novamente.', 'Problema ao pesquisar!')
      );
  }

  pagarDeletar(id: number) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja deletar este contas a pagar?';
    this.bsModalRef.content.confirmar = () => {
      this.lstErros = [];
      this.pagarService.deletar(id).subscribe((data) => {
        this.pagarObterTodos(this.pesquisaPagar, 1);
        //this.obterTotais();
      });
    };
  }

  pagarObterParciais(index: number){
    if (this.lstParciais.length !== 0 && this.lstParciais[0].Participante === this.lstPagar[index].Participante) {
      this.lstParciais = [];
    } else {
      this.mapeamentoParciais = index;
      this.lstParciais = [];
      this.pagarService
        .obterParciais(this.lstPagar[index].Id)
        .toPromise()
        .then(
          (data) => {
            if (data.length === 0) {
              this.toastr.warning('Esse título não possui pagamentos parciais');
            } else {
              this.lstParciais = data;
              this.lstParciais.forEach((parcial) => {
                parcial.Participante = this.lstPagar[index].Participante;
                parcial.ProcessoId = this.lstPagar[index].ProcessoId;
              });
            }
          },
          () => (this.toastr.warning('Houve algum problema'))
        );
    }
  }

  pagarEstorno(id: number) {
    this.bsModalRef = this.modalService.show(ModalConfirmarComponent);
    this.bsModalRef.content.mensagem = 'Deseja estornar este contas a pagar?';
    this.bsModalRef.content.confirmar = () => {
      this.lstErros = [];
      this.pagarService.realizarEstorno(id)
        .subscribe(
          () => {
            this.pagarObterTodos(this.pesquisaPagar, 1);            
            this.obterCredito(this.processoResumo.ClienteId);
            //this.obterTotais();
          },
          (data: any) => {
            if (data.error) {
              this.lstErros = data.error.errors;
              this.toastr.error(data.error.errors);
            }
          }
        );
    };
  }

  pagarAgrupamento() {
    if (this.validaReceberPagar('PAGAR')) {
      this.pagarService.realizarAgrupamento(this.pesquisaPagar.ProcessoId, this.agrupamentoPagarValor)
        .subscribe(
          (data: any) => {
            if (data.error) {
              this.lstErros = data.error.errors;
              this.toastr.error(data.error.errors);
            }
            this.router.navigate(['./pagar/realizarPagamento/' + data.Id, 'processo', this.pesquisaPagar.ProcessoId, this.agrupamentoPagarValor]);
          });
    }
  }

  public pagarPageChanged(event: any): void {
    this.pagarObterTodos(this.pesquisaPagar, event.page);
  }

  filtrar(tipo: string) {

    switch (tipo) {
      case 'naopagas':
        this.pesquisaReceber.PagasRecebidas = false;
        this.pesquisaReceber.NaoPagasRecebidas = true;
        this.pesquisaPagar.PagasRecebidas = false;
        this.pesquisaPagar.NaoPagasRecebidas = true;
        this.tituloPagar = 'A PAGAR';
        this.tituloReceber = 'A RECEBER';
        this.tituloSaldo = 'SALDO';
        break;
      case 'pagas':
        this.pesquisaReceber.PagasRecebidas = true;
        this.pesquisaReceber.NaoPagasRecebidas = false;
        this.pesquisaPagar.PagasRecebidas = true;
        this.pesquisaPagar.NaoPagasRecebidas = false;
        this.tituloPagar = 'PAGO';
        this.tituloReceber = 'RECEBIDO';
        this.tituloSaldo = 'SALDO';
        break;
      case 'todas':
        this.pesquisaReceber.PagasRecebidas = true;
        this.pesquisaReceber.NaoPagasRecebidas = true;
        this.pesquisaPagar.PagasRecebidas = true;
        this.pesquisaPagar.NaoPagasRecebidas = true;
        this.tituloPagar = 'TOTAL (A PAGAR/PAGAS)';
        this.tituloReceber = 'TOTAL (A RECEBER/RECEBIDAS)';
        this.tituloSaldo = 'TOTAL SALDO';
        break;
    }

    this.obterTodos();
    //this.obterSaldo();
   // this.obterTotais();
  }

  obterTodos() {
    this.receberObterTodos(this.pesquisaReceber, 1);
    this.pagarObterTodos(this.pesquisaPagar, 1);
  }

  // obterSaldo() {
  //   this.totalSaldo = this.totalReceber - this.totalPagar;
  //   this.totalSaldo = this.totalSaldo < 0 ? 0 : this.totalSaldo;
  // }

  validaReceberPagar(tipo) {
    let ret = true;
    if ((
      tipo === 'RECEBER' && this.agrupamentoReceberValor === 0) ||
      (tipo === 'PAGAR' && this.agrupamentoPagarValor === 0)) {

      this.toastr.error('O valor de \'baixar parcelas agrupamento\' não pode ser igual a zero.', 'Notificação!');
      ret = false;

    } else if ((
      tipo === 'RECEBER' &&
      this.totalReceber < this.agrupamentoReceberValor) ||
      (tipo === 'PAGAR' && this.totalPagar < this.agrupamentoPagarValor)) {

      this.toastr.error('O valor de \'baixar parcelas agrupamento\' não pode ser maior do que o valor \'TOTAL ' + tipo + '\'.', 'Notificação!');
      ret = false;

    }
    return ret;
  }

}



